import NoFooterModal from "./NoFooterModal";

export default NoFooterModal;
